module.exports = __webpack_public_path__ + "376ca298e5a5c74764b37d74a238ea3b.svg";